/**
 * Initializes the core of TMR Frontend.
 * Brandings should import this at the end of their custom entry point, if any.
 * @file
 */

// Here we are handling Angular Modules, not ES6 Modules!
import * as ngModuleRegistry from './ngModuleRegistry'

/**
 * List of external Angular modules that will be registered as dependencies of the `tmr` module.
 *
 * @alias External Angular Modules
 */
let externalNgModules = [
  'ng',
  'ngAnimate',
  'ngAria',
  'ngCookies',
  'ngMaterial',
  'ngMessages',
  'ngResource',
  'angular-websocket',
  'bw.paging',
  'focus-if',
  'md.time.picker',
  'ngclipboard',
  'pascalprecht.translate',
  'rt.debounce',
  'tmh.dynamicLocale',
  'ui.router',
  'ui.tree',
]

// Add ngModules dependencies from the registry.
let dependencies = externalNgModules.concat(ngModuleRegistry.ngModules())

/**
 * includeDevel is set by webpack.EnvironmentPlugin.
 * true  when developing core with mock enabled
 * false when developing core with mock disabled or when building for distribution
 *       in a customization
 * @todo Add an Environment constants namespace and unify with config/env
 */
if (process.env.includeDevel) {
  dependencies.push('ngMockE2E')
  dependencies.push('ngWebSocketMock')
  dependencies.push('tmr.devel')
}

// Add additional AngularJS modules registered in webpack.config.js
if (process.env.additionalNgModules)
  dependencies.push(...process.env.additionalNgModules)
// Register the core module separated from initialization code for easier testing.
angular.module('tmr.core', dependencies)

// Register the initialization module. It's started by ng-app in index.html.
angular.module('tmr', ['tmr.core']).config(tmrRoutesConfig)

/**
 * Finalize configuration by setting up routes registered by modules.
 * Hardcoded and private because it must run last.
 *
 * @type {ngConfig}
 */
function tmrRoutesConfig(TmrRoutesProvider, tmrDefaultAppState) {
  'ngInject'
  TmrRoutesProvider.setupRoutes(tmrDefaultAppState)
}

// Set some globals on the window object.
if (window !== undefined) {
  window.TMR = {
    version: process.env.version,
    buildDate: process.env.buildDate,
    buildCommit: process.env.buildCommit,
    env: process.env.env,
    mock: process.env.includeDevel,
  }
  if (process.env.brandVersion) {
    window.TMR.brandVersion = process.env.brandVersion
  }
}
